import { Follow, FollowWithUser } from '../../domain/models';
import { FollowRepository } from '../../domain/repositories';
import { FollowDataSource } from '../datasources/FollowDataSource';
import { followEntityToModel, followWithUserEntityToModel } from '../entities';

export class FollowRepositoryImpl implements FollowRepository {
  constructor(private dataSource: FollowDataSource) {}

  async follow(followerId: string, followingId: string): Promise<Follow> {
    const entity = await this.dataSource.create(followerId, followingId);
    return followEntityToModel(entity);
  }

  async unfollow(followerId: string, followingId: string): Promise<void> {
    await this.dataSource.delete(followerId, followingId);
  }

  async getFollowers(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<FollowWithUser[]> {
    const entities = await this.dataSource.getFollowers(userId, limit, offset);
    return entities.map(followWithUserEntityToModel);
  }

  async getFollowing(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<FollowWithUser[]> {
    const entities = await this.dataSource.getFollowing(userId, limit, offset);
    return entities.map(followWithUserEntityToModel);
  }

  async isFollowing(followerId: string, followingId: string): Promise<boolean> {
    return await this.dataSource.isFollowing(followerId, followingId);
  }
}
